module.exports = __webpack_public_path__ + "img/graph-text_5.ee22acc6.svg";